import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IReportingGroupModel extends IModel {
  reportingGroupId: number;
  name: string;
  displayName: string;
  sortOrder: number;
}

export class ReportingGroupModel
  extends Model
  implements ModelRecord<IReportingGroupModel>
{
  reportingGroupId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  constructor(params?: Partial<IReportingGroupModel>) {
    super(params);

    this.reportingGroupId = defaultTo(params?.reportingGroupId, 0);
    this.name = defaultTo(params?.name, '');
    this.displayName = defaultTo(params?.displayName, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
  }
}
